"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function shouldUseBanditOptimization(isOptedIn, isOptedOut, isForcedOn) {
    return isOptedIn && !isOptedOut && !isForcedOn;
}
exports.default = shouldUseBanditOptimization;
